import { addItemToCollection } from "directus/src/operations";

export async function createGrade({ item }) {
  try {
    const data = await addItemToCollection("grades", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
